import { inject } from '@angular/core';
import {
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError,
} from '@angular/router';
import { filter } from 'rxjs/operators';
import { LoaderService } from '@core/services/loader/loader.service';

/**
 * Navigation Loader Interceptor
 * Automatically shows/hides the global loader during route transitions
 */
export function initializeNavigationLoader(): void {
  const router = inject(Router);
  const loaderService = inject(LoaderService);

  router.events
    .pipe(
      filter(
        (event) =>
          event instanceof NavigationStart ||
          event instanceof NavigationEnd ||
          event instanceof NavigationCancel ||
          event instanceof NavigationError
      )
    )
    .subscribe((event) => {
      if (event instanceof NavigationStart) {
        loaderService.setLoading(true);
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        // Small delay to ensure smooth transition
        setTimeout(() => {
          loaderService.setLoading(false);
        }, 100);
      }
    });
}

